/* eslint-disable no-use-before-define */
import React from 'react'
import { Formik } from 'formik'
import { Field,  } from 'formik'
import { Fields, format, STATES, Flyout, getConfig, } from '../twd'
import { ErrorBoundary, useTeyCalculator, getDefaultValues, } from './tey-calculator'

let onValidate = (values) => {
    let err = {}

    if (!values.bondProductType) {
        err.bondProductType = 'Select value'
    }

    let bondYield = parseFloat(values.bondYield)
    if (isNaN(bondYield) || bondYield<0) {
        err.bondYield = 'Enter value'
    }

    if (values.federalTaxRate==='') {
        err.federalTaxRate = 'Select value'
    }

    if (!values.taxState) {
        err.taxState = 'Select value'
    }

    if (values.taxState==='OTHER') {
        let customTaxRate = parseFloat(values.customTaxRate)
        if (isNaN(customTaxRate) || customTaxRate<0) {
            err.customTaxRate = 'Enter value'
        }
    }

    return err
}



export default ({bondType, bondYield, taxState, issueState, onCalcTs, isReset}) => {

    const { state, } = useTeyCalculator()

    let bondProductType = {
        'T': 'tsy',
        'M': 'muni_in',
        'Mo': 'muni_out',
        'C': 'corp',
    }[bondType + (
        bondType==='M' && issueState && issueState !== getConfig('account_states.0.stateOfResidence','')
        ? 'o'
        : ''
    )]

    return <ErrorBoundary>
        <Formik
            initialValues={{
                ...(getDefaultValues().input),
                ...(!bondProductType || isReset ? {} : state.value.input),
                ...(bondProductType && taxState ? { taxState, } : {}),
                ...(bondProductType && bondYield ? { bondYield, } : {}),
                ...(bondProductType ? { bondProductType, } : {}),
            }}
            onSubmit={async (values) => {
                state.set({
                    ...(state.value),
                    input: {...values}
                })
                onCalcTs(Date.now())
            }}
            onReset={async () => {
                let a = getDefaultValues()
                state.set({
                    ...a
                })
                onCalcTs(null)
                return a.input
            }}
            component={Form}

            validate={onValidate}
            validateOnBlur={true}
            validateOnChange={true}
        />
        </ErrorBoundary>
}

let TaxInfo=`
    <table class="table">
    <tbody>
    <tr><td>In-state municipal</td><td class="text-bold">None</td></tr>
    <tr><td>Out-of-state municipal</td><td class="text-bold">State &amp; Local</td></tr>
    <tr><td>Corporate</td><td class="text-bold">Fed, State &amp; Local</td></tr>
    <tr><td>Treasury</td><td class="text-bold">Federal</td></tr>
    </tbody>
    </table>
`

let Form = ({
    handleSubmit,
    handleReset,
    values,
    errors,
    validateForm,
}) => {

    let isOtherState = values.taxState === 'OTHER'

    return <form onSubmit={handleSubmit}>
    <fieldset>
    <div className="row">
        <div className="col-md-6 col-xs-12">
            <legend className="h5">Step 1: Select your starting product and pretax yield</legend>
        </div>
        <div className="col-md-6 col-xs-12 text-right">
        <Flyout
            label="Applicable taxes on interest income"
            className="btn-label btn-flyout tiny-header"
            html={TaxInfo}
        />

        </div>
    </div>

    <div className="row">
        <div className="col-md-6 vertical-offset-base">
        <Field
            dataName="tey-calculator-bond-product-type"
            name="bondProductType"
            component={Fields.Select}
            label="Bond product type"
            options={[
                {label:'', value:''},
                {label:'In-state municipal', value:'muni_in'},
                {label:'Out-of-state municipal', value:'muni_out'},
                {label:'Corporate', value:'corp'},
                {label:'Treasury', value:'tsy'}
            ]}
        />
        </div>
        <div className="col-md-6 vertical-offset-base">
        <Field
            data-name="tey-calculator-bond-yield"
            name="bondYield"
            component={Fields.Yield}
            label="Bond yield"
            suffix="%"
            error={errors.bondYield}
        />
        </div>
    </div>
    </fieldset>

    <fieldset>
    <div className="row">
        <div className="col-md-12">
            <legend className="h5">Step 2: Choose your federal and state income tax rates</legend>
        </div>
    </div>

    <div className="row">
        <div className={(isOtherState ? "col-md-3" : "col-md-4") + " vertical-offset-base"}>
        <Field
            dataName="tey-calculator-federal-tax-rate"
            name="federalTaxRate"
            component={Fields.Select}
            label="Federal tax rate"
            options={
                ['', 0, .1, .12, .22, .24, .32, .35, .37]
                .map((a) => ({
                    label: Number.isFinite(a) ? format.pct(a * 100) : '',
                    value: String(a)
                }))
            }
        />
        </div>
        <div className={(isOtherState ? "col-md-3" : "col-md-4") + "  vertical-offset-base"}>
        <Field
            dataName="tey-calculator-state-tax-rate"
            name="taxState"
            component={Fields.Select}
            label="State tax rate"
            options={
                [{
                    label: '',
                    value: '',
                }, {
                    label: 'Other',
                    value: 'OTHER',
                }]
                .concat(STATES
                    .map(a => {
                        let s = a.value
                        let r = (global.app.config.state_tax_rates || {})[s] || 0
                        return {
                            label: `${a.label} - ${format.pct(r*100)}`,
                            value: `${s}`
                        }
                    })
                    .sort((a,b) => {
                        return a.label.localeCompare(b.label, 'en', {sensitivity:'base'})
                    })
                )
            }
        />
        </div>

        {isOtherState && <div className="col-md-3 vertical-offset-base">
        <Field
            data-name="tey-calculator-custom-tax-rate"
            name="customTaxRate"
            component={Fields.Yield}
            label="Custom tax rate"
            suffix="%"
            error={errors.customTaxRate}
        />
        </div>}

        <div className={(isOtherState ? "col-md-3" : "col-md-4")}>
            <label className="xs-hide">&nbsp;</label>
            <button
                type="submit"
                className="btn btn-primary btn-block"
                disabled={errors.length>0}
            >Calculate</button>
            <button
                type="button"
                className="btn btn-link btn-block text-center"
                onClick={() => {
                    handleReset()
                    setTimeout(() => validateForm, 10)
                }}
            >Clear form</button>
        </div>
    </div>
    </fieldset>
   </form>
}


// WEBPACK FOOTER //
// ./src/tey-calculator/input.js